import React from 'react';

export const useIntersectionObserver = (options = {}) => {
  const {
    threshold = 1,
    root = null,
    rootMargin = '0px',
    persistIntersection = false, // If true, keeps the entry after first intersection
  } = options;
  const [entry, setEntry] = React.useState(null);
  const [hasIntersected, setHasIntersected] = React.useState(false);
  const previousObserver = React.useRef(null);

  const customRef = React.useCallback(
    (node) => {
      if (previousObserver.current) {
        previousObserver.current.disconnect();
        previousObserver.current = null;
      }

      if (node?.nodeType === Node.ELEMENT_NODE) {
        const observer = new IntersectionObserver(
          ([e]) => {
            if (e.isIntersecting) {
              setHasIntersected(true);
              setEntry(e);

              // Only disconnect if persistIntersection is true
              if (persistIntersection) {
                observer.disconnect();
                previousObserver.current = null;
              }
            } else if (!persistIntersection || !hasIntersected) {
              // For non-intersecting entries:
              // If persistIntersection=false OR element hasn't intersected yet, update entry
              if (!persistIntersection || !hasIntersected) {
                setEntry(e);
              }
              // When persistIntersection=true and already intersected, keep old entry
            }
          },
          { threshold, root, rootMargin }
        );

        observer.observe(node);
        previousObserver.current = observer;
      }
    },
    [threshold, root, rootMargin, hasIntersected, persistIntersection]
  );

  return [customRef, entry];
};
